/**
 * Recently Played Games Store Collection
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var core = require('core');
    var BaseCollection = require('common/base.collection');
    var user = require('user');
    var RecentlyPlayedGamesModel = require('stores/recently-played-games/recently-played-games.model');

    module.exports = BaseCollection.extend({

        model: RecentlyPlayedGamesModel,

        sync: function(method, model, options) {
            if (!user.isLoggedIn()) {
                return $.Deferred().resolve();
            }

            if (method === 'read') {
                return this._read(model, options);
            }
        },

        _read: function(model, options) {
            return user.getPlayerTags('uam/hidden/playerRecentGames').done(options.success).fail(options.error);
        },

        parse: function(response) {
            var tags = response.data && response.data.tags;
            var value;

            if (!tags.length) {
                return [];
            }

            try {
                value = tags[0].value;
                return typeof value === 'string' ? JSON.parse(tags[0].value) : value;
            } catch(e) {
                core.error('Error Recent Games Response Parse');
                return [];
            }
        }
    });
});
